import OwButton from "@components/shared/OwButton/OwButton";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import AccessTypesEnum from "@models/AccessTypesEnum";
import IOrder from "@models/IOrder";
import OrderStatesEnum from "@models/OrderStatesEnum";
import React, { useContext, useState } from "react";
import { OrderTotalsPanel } from "../OrderTotalsPanel/OrderTotalsPanel";
import UserContext from "@contexts/UserContext";
import ISubmitOrderDTO from "@models/DTO/ISubmitOrderDTO";
import OrderEntryService from "@services/OrderEntryService";
import { NumericFormat } from "react-number-format";
import SupplierContext from "@contexts/SupplierContext";

type Props = {
    order: IOrder;
    shouldHidePricingFn: () => boolean;
    submitOrder: (payload: ISubmitOrderDTO) => void;
    reviewAndSubmit: () => void;
};

export const EcommerceCartOrderTotalsHeader = ({ order, shouldHidePricingFn, submitOrder, reviewAndSubmit }: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [isActive, setIsActive] = useState(false);

    const getQuickReview = () => {
        let buttonTitle = "review_and_submit";

        if (order?.order_state_id !== OrderStatesEnum.PRELIMINARY || order?.is_template || order?.is_quote) {
            buttonTitle = "review";
        }

        return (
            <div className={"d-flex flex-column justify-content-center align-items-center text-center w-100"}>
                <div className="w-100">
                    <OwButton
                        title={buttonTitle}
                        fn={reviewAndSubmit}
                        active={isActive}
                        disableOnActive={true}
                        disabled={order?.Order_Items?.length === 0}
                    />
                </div>
                <div className={"subtotal d-flex"}>
                    <OwLabel title={"subtotal"} className={"me-2"} postText={":"} isBold={true} />
                    <div className={"value"}>
                        <NumericFormat
                            value={(order?.sub_total || 0) - (order?.discount_total || 0)}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            prefix={"$"}
                        />
                    </div>
                </div>
            </div>
        );
    };

    // const getTotals = () => {
    //     let orderStateName = order?.Order_State?.name.toLowerCase() || "";

    //     if (orderStateName === "in_product") {
    //         orderStateName = "confirmed";
    //     }

    //     return (
    //         <React.Fragment>
    //             <div className={"mb-4"}>
    //                 {order?.order_state_id === OrderStatesEnum.PRELIMINARY &&
    //                 !(userModel?.supplierUserToken?.access_type_id === AccessTypesEnum.READ_ONLY) ? (
    //                     <OwButton title={"submit"} fn={submitOrderFn} active={isActive} disableOnActive={true} />
    //                 ) : (
    //                     <OwLabel title={orderStateName} isBold={true} className={"text-warning"} />
    //                 )}
    //             </div>
    //             <div className={"totals"}>
    //                 {order ? (
    //                     <OrderTotalsPanel
    //                         shouldHidePricingFn={shouldHidePricingFn}
    //                         order={order}
    //                         orderItemType={"default"}
    //                         isEcommerceView={true}
    //                     />
    //                 ) : null}
    //             </div>
    //         </React.Fragment>
    //     );
    // };

    return <div className={"EcommerceCartOrderTotalsHeader w-100"}>{getQuickReview()}</div>;
};
